import { useMemo, useState } from "react";

/**
 * @param initialData - The initial data to filter
 * @param predicate - A predicate function to filter the data. If not provided, the data will be filtered by the name of the item.
 * @returns An object with the setInput function and the filtered data
 */
export function useFilter<T extends string | { name?: string }>(
  initialData: T[],
  predicate?: (item: T, normalizedInput: string) => boolean
) {
  const [input, setInput] = useState("");

  const data = useMemo(() => {
    const normalizedInput = input.toLowerCase().trim();

    return initialData.filter(item => {
      if (predicate) {
        return predicate(item, normalizedInput);
      }

      const label = typeof item === "string" ? item : (item.name ?? "");

      return label.toLowerCase().includes(normalizedInput);
    });
  }, [input, initialData, predicate]);

  return {
    setInput,
    data,
  };
}
